module.exports = __webpack_public_path__ + "static/img/img_16.ad41e9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/children_gallery/img_16.jpg
// module id = jO86
// module chunks = 0